/* script */
































import Vue from 'vue';
import Component from 'vue-class-component';

type Item = {
    id: number;
    house_id: number;
    billing_item_id: number;
    category: string;
    sales_unit: 'quantity_unit' | 'time_unit';
    arrange: number;
    unit_price: number;
    tag: Tag | null;
    sales_start_time: string;
    sales_end_time: string;
    merchandise_recommendation: MerchandiseRecommendation;
    image_urls: string[];
    texts: Record<TextProperty, LocaleText>;
    stock: number;
    need_seat_selection: boolean;
};

type MerchandiseRecommendation = {
    is_general: boolean;
    valid: number;
};
type TextProperty = 'title' | 'catch_copy' | 'description' | 'notice' | 'unit';

type Lang = 'ja' | 'en' | 'cn' | 'ko';

type LocaleText = Record<Lang, string>;

type Tag = 'new' | 'limited' | 'recommended';

@Component({
    name: 'merchandise-item-card',
    props: ['merchandiseItem', 'lang', 'amount', 'clickable'],
})
class MerchandiseItemCard extends Vue {
    merchandiseItem!: Item;
    amount!: number;
    lang!: Lang;
    clickable!: boolean;

    setMerchandiseItem() {
        if (this.clickable) {
            this.$emit('setMerchandiseItem', this.merchandiseItem.id);
        }
    }

    // fitTagScale(){
    //     const tag = this.$refs.tag as HTMLSpanElement;
    //     if(!tag) return;

    //     tag.style.transform = '';
    //     const rawWidth = tag.clientWidth;
    //     const scale = Math.floor(60 * tag.parentElement!.clientWidth / rawWidth) / 100;
    //     tag.style.transform = scale < 1 ? `scale(${scale})` : '';
    // }
}
const __vue_script__ = MerchandiseItemCard;

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card",
      attrs: { id: "merchandise_item_card" },
      on: {
        click: function ($event) {
          return _vm.setMerchandiseItem()
        },
      },
    },
    [
      _vm.merchandiseItem.image_urls.find(function (image_url) {
        return image_url
      })
        ? _c("img", {
            attrs: {
              src: _vm.merchandiseItem.image_urls.find(function (image_url) {
                return image_url
              }),
            },
          })
        : _c("div", { staticClass: "no_img" }, [
            _c("span", {
              staticClass: "icon",
              attrs: { "before-icon": "photo_camera" },
            }),
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "texts" }, [
        _c("h2", { staticClass: "merchandise_name" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.merchandiseItem.texts.title[_vm.lang]) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "description" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.merchandiseItem.texts.catch_copy[_vm.lang]) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "price" },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm._f("price")(_vm.amount)) +
                "\n            "
            ),
            _vm.merchandiseItem.texts.unit[_vm.lang]
              ? [
                  _vm._v(
                    "\n                / " +
                      _vm._s(_vm.merchandiseItem.texts.unit[_vm.lang]) +
                      "\n            "
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "script_src/common/merchandise/MerchandiseItemCard.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__